import Vue from "vue";
import http from "./helper/http-common";
import { store } from './store';
import bus from "./helper/eventBus";
import dataLayerService from "./helper/dataLayer";
import VueTheMask from "vue-the-mask";
import ContactFrom from "./components/ContactForm.vue";
import CompaniesList from "./components/companies/List.vue";
import NotificationPopup from "./components/reusable/NotificationPopup.vue";
import FullPageLoading from "./components/reusable/FullPageLoading.vue";
import TerminsContainer from "./components/info/termins/Container.vue";
import LegislationContainer from "./components/info/legislation/Container.vue";
import FaqContainer from "./components/info/faq/Container.vue";
import InsuranceContainer from "./components/info/insurance/Container.vue";
import IcbariAuto from "./components/icbari/auto/AutoContainer.vue";
import PashaExtra from "./components/icbari/extra/pasha-extra/PashaExtraContainer.vue";
import PropertyIcbari from "./components/icbari/property/PropertyContainer.vue";
import TravelContainer from "./components/icbari/travel/TravelContainer.vue";
import TravelGurcustanContainer from "./components/icbari/travel-gurcustan/TravelGurcustanContainer.vue";
import TamKaskoContainer from "./components/kasko/tam-kasko/TamKaskoContainer.vue";
import FeedbackContainer from "./components/communication/feedback/FeedbackContainer.vue";
import KaskoCalculator from "./components/kasko/agroup/KaskoCalculator.vue";
import ParkingContainer from "./components/kasko/parking/ParkingContainer.vue";
import TouristContainer from "./components/kasko/tourist/TouristContainer.vue";
import LifeContainer from "./components/kasko/life/LifeContainer.vue";
import OnlineKasko from "./components/kasko/online/OnlineKasko.vue";
import LikeDislikeBtn from "./components/communication/offers/LikeDislikeBtn.vue";
import ProfileContainer from "./components/Cabinet/Profile/ProfileContainer.vue";
import PartnershipContainer from "./components/Cabinet/Partnership/PartnershipContainer.vue";
import AddContractContainer from "./components/Cabinet/AddContract/AddContractContainer.vue";
import CompanyCommissionsTable from "./components/Cabinet/Commissions/CompanyCommissionsTable.vue";
// Global assetUrl helper function
var assetUrl = function (path) {
    var baseUrl = window.$assetUrl || '';
    return baseUrl + '/' + path;
};
// Global function for company ranking URL
var getRankingUrl = function (companyId) {
    var locale = document.documentElement.lang || 'az';
    var baseUrl = window.$domain;
    if (locale == 'az') {
        locale = '';
    }
    else {
        locale = '/' + locale;
    }
    return "".concat(baseUrl).concat(locale, "/companies/ranking/").concat(companyId);
};
// Global function for feedback URL with filters
var getFeedbackUrl = function (filterFeedback, filterCompanies) {
    if (filterFeedback === void 0) { filterFeedback = ''; }
    if (filterCompanies === void 0) { filterCompanies = ''; }
    var locale = document.documentElement.lang || 'az';
    var baseUrl = window.$domain;
    if (locale == 'az') {
        locale = '';
    }
    else {
        locale = '/' + locale;
    }
    return "".concat(baseUrl).concat(locale, "/communication/feedback?filter_feedback=").concat(filterFeedback, "&filter_companies=").concat(filterCompanies);
};
Vue.use(VueTheMask);
Vue.prototype.$http = http;
Vue.prototype.$bus = bus;
Vue.prototype.assetUrl = assetUrl;
Vue.prototype.$getRankingUrl = getRankingUrl;
Vue.prototype.$getFeedbackUrl = getFeedbackUrl;
Vue.prototype.$dataLayer = dataLayerService;
Vue.component('contact-form', ContactFrom);
Vue.component('companies-list', CompaniesList);
Vue.component('notification-popup', NotificationPopup);
Vue.component('fullpage-loading', FullPageLoading);
Vue.component('termins-container', TerminsContainer);
Vue.component('legislation-container', LegislationContainer);
Vue.component('icbari-auto', IcbariAuto);
Vue.component('pasha-extra', PashaExtra);
Vue.component('property-icbari', PropertyIcbari);
Vue.component('faq-container', FaqContainer);
Vue.component('insurance-types-container', InsuranceContainer);
Vue.component('travel-container', TravelContainer);
Vue.component('travel-gurcustan-container', TravelGurcustanContainer);
Vue.component('tam-kasko-container', TamKaskoContainer);
Vue.component('feedback-container', FeedbackContainer);
Vue.component('kasko-calculator', KaskoCalculator);
Vue.component('parking-container', ParkingContainer);
Vue.component('tourist-container', TouristContainer);
Vue.component('life-container', LifeContainer);
Vue.component('online-kasko', OnlineKasko);
Vue.component('like-dislike-btn', LikeDislikeBtn);
Vue.component('profile-container', ProfileContainer);
Vue.component('partnership-container', PartnershipContainer);
Vue.component('add-contract-container', AddContractContainer);
Vue.component('company-commissions-table', CompanyCommissionsTable);
new Vue({
    store: store,
    el: '#vue-layout',
    provide: function () {
        return {};
    }
});
